const componentForm = {
  administrative_area_level_1: "short_name" /* state/province/territory */,
  country: "long_name",
  locality: "long_name" /* city */,
  neighborhood: "long_name",
  postal_code: "short_name",
  postal_town: "short_name", // City/town
  premise: "long_name",
  route: "long_name" /* street name */,
  street_number: "short_name",
  sublocality: "long_name",
  subpremise: "short_name" /* apt/unit */,
}

// Finds a Google Autocomplete Address Component
export const findComp = (type, components) => {
  var nameForm = "short_name"
  if (componentForm[type] !== "undefined") {
    nameForm = componentForm[type]
  }

  var component = (components || []).filter(function (obj) {
    return obj["types"].includes(type)
  })

  if (component.length > 0) {
    return component[0][nameForm]
  }
  return ""
}

export const countries = {
  au: "Australia",
  ca: "Canada",
  gb: "United Kingdom",
  uk: "United Kingdom",
  us: "United States",
}

export const defaultFormFields = {
  address1: "address1",
  address2: "address2",
  city: "city",
  postal_code: "postal_code",
  state: "state",
}
